import { Flex, Icon, Stack } from '@chakra-ui/react';
import { IconEdit, IconTrash } from '@tabler/icons';
import React, { useState } from 'react';

import ModalDelete from '../modalDelete';
import ModalRegisterEditFamily from '../modalRegisterEditFamily';

interface FamilyEditDeleteIconsProps {
	row: any;
}

const FamilyEditDeleteIcons: React.FC<FamilyEditDeleteIconsProps> = props => {
	const { row } = props;
	const selectedId = row?.CheckBox;
	const rowData = row;
	const [isOpenEdit, setIsOpenEdit] = useState(false);
	const [isOpenDelete, setIsOpenDelete] = useState(false);

	const getModalType = () => {
		const module = row?.button?.filterModule;

		switch (module) {
			case 'family':
				return 'family';
			case 'subfamily':
				return 'subFamily';
			case 'model-product':
				return 'productModel';
			default:
				return 'family';
		}
	};

	return (
		<>
			<Flex
				cursor='pointer'
				h='max-content'
				w='max-content'
			>
				<Stack
					direction='row'
					alignSelf={{ base: 'unset', md: 'flex-end' }}
					spacing='8px'
				>
					<Icon
						color='secondaryGray.500'
						as={IconEdit}
						w='20px'
						h='20px'
						onClick={() => setIsOpenEdit(true)}
					/>
					<Icon
						color='secondaryGray.500'
						as={IconTrash}
						w='20px'
						h='20px'
						onClick={() => setIsOpenDelete(true)}
					/>
				</Stack>
			</Flex>

			{isOpenEdit && (
				<ModalRegisterEditFamily
					type={getModalType()}
					isOpen={isOpenEdit}
					onClose={() => setIsOpenEdit(false)}
					autocompleteAdditionalData={{
						id: selectedId,
						nome_familia: rowData.nome_familia,
						nome_sub_familia: rowData.nome_sub_familia,
						nome_modelo: rowData.nome_modelo,
					}}
				/>
			)}

			{isOpenDelete && (
				<ModalDelete
					type={getModalType()}
					isOpen={isOpenDelete}
					onClose={() => setIsOpenDelete(false)}
					removeId={selectedId}
				/>
			)}
		</>
	);
};

export default FamilyEditDeleteIcons;
